import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clean URL immediately
    if (window.history?.replaceState) {
      window.history.replaceState(null, "", window.location.pathname);
    }

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        setUser(res.data);
        if (res.data?.is_admin) {
          navigate("/admin", { replace: true, state: { user: res.data } });
        } else {
          navigate("/admin/denied", { replace: true, state: { user: res.data } });
        }
      } catch {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-950 text-white">
      <div className="flex items-center gap-3 text-sm">
        <Loader2 className="w-5 h-5 animate-spin" />
        Connexion en cours...
      </div>
    </div>
  );
}
